import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "itemContainer", "itemTemplate", "entry", "entryContainer", "entryTemplate"]

  connect() {
    console.log("InvoiceItemController connected")
  }

  addItem(event) {
    event.preventDefault();
    const content = this.itemTemplateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.itemContainerTarget.insertAdjacentHTML('beforeend', content);
  }

  removeItem(event) {
    event.preventDefault();
    const item = event.target.closest('[data-invoice-item-target="item"]');
    if (item) {
      item.remove();
      this.dispatch("itemRemoved", { bubbles: true });
    }
  }

  addEntry(event) {
    event.preventDefault();
    const entryContainer = event.target.closest('[data-invoice-item-target="item"]').querySelector('[data-invoice-item-target="entryContainer"]');
    const entryTemplate = event.target.closest('[data-invoice-item-target="item"]').querySelector('[data-invoice-item-target="entryTemplate"]');
    if (entryContainer && entryTemplate) {
      const content = entryTemplate.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
      entryContainer.insertAdjacentHTML('beforeend', content);
    }
  }
  
  removeEntry(event) {
    event.preventDefault();
    const entry = event.target.closest('[data-invoice-item-target="entry"]');
    if (entry) {
      entry.remove();
    }
  }
} 
